import styled from 'styled-components';

export const StyledKeyValueTable = styled.table`
    display: block;
`;

export const StyledKeyValueTableBody = styled.tbody`
    display: block;
`;
